export default __webpack_public_path__ + "static/media/back button animated.16203d41.svg";